<template>
    <div class="user-block">
        <div class="num">2</div>
        <el-image :src="require('@/assets/images/img.png')" fit="cover">
            <div slot="error" class="image-slot"/>
        </el-image>
        <div class="name">
            張大大
        </div>
        <div class="fee red">$420</div>
    </div>
</template>

<script>

    export default {
        name: "User",
        props: {

        },
        data() {
            return {

            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>

